// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2V1uZ","alert":"SettungsInbox_alert__1A3do"};